import { Selector } from '../../lib/generated/zeus';

export const eventSelector = Selector('event')({
  created_at: true,
  created_by: true,
});
